import {otherApi} from '../../api';
import LanguageFile from '../../common/lang/lang';
import RegionFile from '../../common/countries/data';
import _ from 'lodash';

export function getLanguageIndex(language) {
  let index=0;
  for(let i=0;i<LanguageFile.languages.length;i++){
      let lan=LanguageFile.languages[i];
      if(lan===language){
          index=i;
          break;
      }
  }
  return index;
};

export function getFiledValue (language,txt)  {
  let i=getLanguageIndex(language);
  return LanguageFile.fileds[txt][i];
};

export function setAppTheme(theme_name) {
    return dispatch => {
      dispatch({
        type: "APP_SET_THEME",
        theme_name:theme_name
      });
    }
}

export function setLanguage(lan) {
  return dispatch => {
    dispatch({
      type: "APP_SET_LANGUAGE",
      language:lan
    });
  }
}
export function setAllLanguages() {
  return async dispatch => {
    try {
        dispatch({
          type: "APP_SET_LANGUAGES",
          languages:LanguageFile.languages
        });
    } catch (error) {
      console.log(error.message);
        dispatch({
          type: "APP_SET_LANGUAGES",
          languages:['en']
        });
    }
    
  }
}

function filterBMOs(ar){
 return  _.filter(ar, function(currentObject) {
    return currentObject.node.is_active === true;
});
}

export function setGeneralData() {
  return async dispatch => {
    try {
      otherApi.fetchGeneralData().then(result=>{
         let res=result.data;
        dispatch({
          type: "APP_SETCOMMON_DATA",
          bmos:filterBMOs(res.bMOs.edges),
          industries:res.industries.edges,
          countries:res.countries.edges,
          faq_categories:res.faq_categories.edges,
          settings: res.allSettings,
          tags:res.tags.edges
        });

      });
    } catch (error) {
      
    }  
  }
}


function checkExists_regions(countries,val){
    let state=false;
    for(let i=0;i<countries.length;i++){
      if(val.toUpperCase()===countries[i].node.name.toUpperCase()){
        state=true;
      }
    }
    return state;
}

function checkRegionCountries(regionobj,country){
  let state=false;
  const arresp = RegionFile.filter(function (el) {
    return (regionobj.region===el.region);
  });
  for(let i=0;i<arresp.length;i++){
      if(arresp[i].country.toUpperCase()===country){
        state=true;
        break;
      }
  }
  return state;
}

function checkExists_countries(arregions,country){
  let state=false;
  for(let i=0;i<arregions.length;i++){
     if(checkRegionCountries(arregions[i].value,country.toUpperCase())){
      state=true;
      break;
     }
  }
  return state;
}

export function convertRegionalData(arregions){
    let ar=[];
    arregions.forEach(function(entry) {
        let obj={};
        obj['value']=entry;
        obj['label']=entry.region;
        obj['key']=entry.region;


        if(!ar.some(item => item.key === entry.region)){
          ar.push(obj);
        }
       
    });
    return ar;
}

export function setRegionData(countries) {
  return async dispatch => {
    try {
  
      const respJson = RegionFile;
     
      const arreg=respJson.filter(function (el) {
        return checkExists_regions(countries,el.country);
      });

    dispatch({
        type: "APP_SET_REGIONS",
        regions:convertRegionalData(arreg)
      });
   
    } catch (error) {
      console.log(`error in regional data`,error)
    }
  }
}



export function getRegionCountries(arregions,countries){
  const arcount=countries.filter(function (el) {
    return checkExists_countries(arregions,el.node.name);
  });
  return arcount;
}






